import { Brand, Industry, ProductCategory } from "../../utils/enums.utils";
import { MonitoringAttachmentsStatus, MonitoringStatus } from "./monitorings-response.interface";

export interface CreateMonitoringsInterface {
  status: MonitoringStatus;
  category: string;
  monitoring_remarks: string | null;  
  buying_amount_vat_inc: number | null;
  selling_amount_vat_inc: number | null;
  estimated_gross_profit: number | null;
  mark_up: number | null;
  selling_amount_vat_ex: number | null;
  project_code: string | null;
  industry: Industry;
  product_category: ProductCategory;
  brand: Brand;
  project_name: string | null;
  proposal_id: string;
  company_id: string;
  created_by_id: string | null;
  updated_by_id: string | null;
}

export interface UpdateMonitoringsInterface {
  id: string;
  status?: MonitoringStatus;
  category?: string;
  monitoring_remarks?: string | null;  
  buying_amount_vat_inc?: number | null;
  selling_amount_vat_inc?: number | null;
  estimated_gross_profit?: number | null;
  mark_up?: number | null;
  selling_amount_vat_ex?: number | null;
  project_code?: string | null;
  industry?: Industry;
  product_category?: ProductCategory;
  brand?: Brand;
  project_name?: string | null;
  company_id?: string;
  updated_by_id: string | null;
}

export interface CreateMonitoringAttachmentsInterface {
  monitoring_id: string;
  attachment_id: string;
  status: MonitoringAttachmentsStatus;
}

export interface UpdateMonitoringAttachmentsInterface {
  monitoring_id: string;
  attachment_id: string;
  status: MonitoringAttachmentsStatus;
}